export default __webpack_public_path__ + "79ab2aca8d71916c11b48d57c3e96d7e.jpg";